import { createFileRoute, redirect, Outlet, useNavigate } from '@tanstack/react-router'

import { MainLayout } from '@/components/main-layout'
import { authToken } from '@/hooks/use-auth'
import { Sidebar } from '@/routes/_authenticated/_general/-sidebar'
import { useWatchObservable } from '@/utils/hooks'

export const Route = createFileRoute('/_authenticated')({
	beforeLoad: ({ location }) => {
		if (!authToken.value) {
			throw redirect({
				to: '/login',
				search: {
					// Save current location for redirect after login
					redirect: location.pathname === '/' ? undefined : location.pathname
				}
			})
		}
	},
	component: AuthenticatedComponent
})

function AuthenticatedComponent() {
	const navigate = useNavigate()
	useWatchObservable(
		authToken,
		token => {
			if (!token) {
				navigate({
					to: '/login',
					search: {
						redirect: location.pathname === '/' ? undefined : location.pathname
					}
				})
			}
		},
		[]
	)
	return <Outlet />
}
